/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
  Route,
  Redirect,
  RouteProps
} from 'react-router-dom'
// Local
import { PAGES } from '../../constant'

type PrivateRouteProps = RouteProps & {
  component: React.ComponentType<any>
  authenticated: boolean
}

function PrivateRoute(props: PrivateRouteProps): JSX.Element {
  const {
    component: Component,
    authenticated: isAuthenticated,
    ...rest
  } = props

  if (!isAuthenticated) {
    return (
      <Redirect to={ PAGES.LOGIN } />
    )
  }
  return (
    <Route
      { ...rest }
      render={
        routeProps => (
          <Component { ...routeProps } />
        )
      }
    />
  )
}

export default PrivateRoute
